import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogTitle, MenuItem, MuiThemeProvider, TextField, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import TableCustom from '../../../../Components/Table';

import { buscarRemuneracoesRetencoes } from '../../../../Store/Actions/API/relacoesPrevidenciariasActions';
import temaFormulario from '../../../../Styles/Temas/temaFormulario';
import { useStyles } from './styles';
import { formataNomeCompetencia, formatarReais } from '../../../../Utils/utils';

export default function ModalMaisDetalhes({ cpf, relacaoSelecionada, open, fechar }) {

    const primeiroRenderRealizado = useRef(false);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
    const classes = useStyles();

    const [isLoading, setLoading] = useState(false);

    const [anoSelecionado, setAnoSelecionado] = useState(null);
    const [anos, setAnos] = useState([]);
    const [remuneracoes, setRemuneracoes] = useState([]);

    useEffect(() => {
        if (anoSelecionado !== null && primeiroRenderRealizado.current === false) {
            primeiroRenderRealizado.current = true;
        } else {
            lidarListaRemuneracoes();
        }
    }, [anoSelecionado]); // eslint-disable-line

    const lidarListaRemuneracoes = async () => {
        setLoading(true);

        const filtros = { idRelacao: relacaoSelecionada.id, cpf, anoSelecionado: anoSelecionado ? anoSelecionado : '' };

        const response = await buscarRemuneracoesRetencoes(filtros);

        setLoading(false);

        if (response === null) {
            if (anos.length === 0) {
                fechar();
            }
            return;
        } else {
            setAnos(response.anos);
            if (anoSelecionado === null) {
                setAnoSelecionado(response.anos[0]);
            }
            setRemuneracoes(response.remuneracoes);
        }
    }

    const onChangeAnoSelecionado = (event) => {
        let value = event.target.value;
        if (value !== anoSelecionado) {
            setAnoSelecionado(value);
        }
    }

    const columns = [
        {
            title: "Competência",
            dataIndex: "competencia",
            key: "competencia",
            align: "center",
            width: 60,
            render: (value, row) => <p style={{ fontSize: 13 }}>{formataNomeCompetencia(value)}</p>,
        },
        {
            title: "Remuneração",
            dataIndex: "remuneracao",
            key: "remuneracao",
            align: "center",
            width: 100,
            render: (value, row) => <p style={{ fontSize: 13 }}>{formatarReais(value)}</p>,
        },
        {
            title: "Valor da Retenção INSS",
            dataIndex: "retencaoINSS",
            key: "retencaoINSS",
            align: "center",
            render: (value, row) => <p style={{ fontSize: 13 }}>{(value && value !== '-') ? formatarReais(value) : '-'}</p>,
        }
    ];

    const propsTable = {
        columns,
        data: remuneracoes,
        heightBody: "400px",
        minHeightBody: "180px",
        removeHeaderBackground: true,
        marginBorder: true,
        width: '100%',
        elevationPaper: 0,
        useLoading: true,
        loading: isLoading
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            fullWidth
            maxWidth={"xs"}
            open={open}
            onClose={fechar}
            aria-labelledby="modal-mais-detalhes"
        >
            <MuiThemeProvider theme={temaFormulario}>
                <DialogTitle id="modal-mais-detalhes" style={{ backgroundColor: '#D4BFF9' }}>
                    <CloseIcon style={{ float: 'right', cursor: 'pointer' }} onClick={() => fechar()}>
                        <CloseIcon />
                    </CloseIcon>
                    <Typography style={{ fontWeight: 700 }}>
                        {"REMUNERAÇÕES E RETENÇÕES"}
                    </Typography>
                </DialogTitle>
            </MuiThemeProvider>
            <div className={classes.mainContent}>
                <MuiThemeProvider theme={temaFormulario}>
                    <div className={classes.header}>
                        <div className={classes.col1}>
                            <Typography className={classes.headerText}>Ano de consulta:</Typography>
                        </div>
                        <div className={classes.col2}>
                            <TextField
                                select
                                id="select_tipoVinculo"
                                color='secondary'
                                variant="outlined"
                                size='small'
                                margin='dense'
                                value={anoSelecionado}
                                disabled={isLoading}
                                style={{ width: 150, height: 35 }}
                                SelectProps={{
                                    style: { height: 35, fontSize: 13 }, 
                                    MenuProps: {
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left"
                                        },
                                        transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left"
                                        },
                                        getContentAnchorEl: null
                                    }
                                }}
                                inputProps={{ style: { height: 35 } }}
                                InputProps={{ style: { height: 35 } }}
                                onChange={onChangeAnoSelecionado}
                            >
                                {anos.map((ano, index) => (
                                    <MenuItem key={index} style={{ fontSize: 13 }} value={`${ano}`}>{`${ano}`}</MenuItem>
                                ))}
                            </TextField>
                        </div>
                    </div>
                </MuiThemeProvider>
                <TableCustom {...propsTable} />
            </div>
        </Dialog>
    )
}